module.exports = __webpack_public_path__ + "img/p2AR_btn_entry.84900519.png";